import Swiper from '../../../../../vendor/swiper/swiper-bundle.mjs';
export default class CasesSwiper {
    constructor($el) {
        this.$el = $el;
        this.$imageSwiper = this.$el.querySelector('[data-cases-swiper]');
        this.$titleSwiper = this.$el.querySelector('[data-cases-title-swiper]');
        this.$prev = this.$el.querySelector('[data-case-prev]');
        this.$next = this.$el.querySelector('[data-case-next]');

        this.slide = this.slide.bind(this);
        this.slide();
    }

    slide() {
        if (!this.$imageSwiper) {
            return;
        }

        const imageSwiper = new Swiper(this.$imageSwiper, {
            slidesPerGroup: 1,
            loop: true,
            navigation: {
                nextEl: this.$next,
                prevEl: this.$prev,
            },

        });

        if (!this.$titleSwiper) {
            return;
        }

        const titleSwiper = new Swiper(this.$titleSwiper, {
            slidesPerGroup: 1,
            loop: true,
        });

        imageSwiper.controller.control = titleSwiper;
        titleSwiper.controller.control = imageSwiper;
    }
}
